// Styles
import "material-design-icons-iconfont/dist/material-design-icons.css"
import "@mdi/font/css/materialdesignicons.css"
import "@fortawesome/fontawesome-free/css/all.css";
import "vuetify/styles";
import colors from 'vuetify/lib/util/colors'

// Vuetify
import { createVuetify } from "vuetify";

const humanitas = {
  dark: false,
  colors: {
    background: "#F3F6FA",
    surface: "#FFFFFF",
    primary: "#16324A",
    'primary-darken-1': '#0D1F2E',
    'primary-litghen-1': '#D7E6F4',
    secondary:'#3C6E8F',
    tertiary: '#B88645',
    'tertiary-litghen-1': '#F1F7F3',
    error: "#B42318",
    info: "#2F6F91",
    success: "#2E7D5B",
    warning: "#C27A2C",
  },
};

export default createVuetify({
  icons: {
    iconfont: 'md' || 'fa'
  },
  theme: {
    defaultTheme: 'humanitas',
    themes: {
      light: {
        background: colors.blue.gray,
      },
      dark: {
        background: colors.shades.white,
      },
      humanitas,
    },
  },

});
